/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * The resident's answer to an open last look: match the outside offer's price, or pass.
 * @export
 * @interface HomeownershipLastLookAnswerRequest
 */
export interface HomeownershipLastLookAnswerRequest {
    /**
     * 
     * @type {string}
     * @memberof HomeownershipLastLookAnswerRequest
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipLastLookAnswerRequest
     */
    lastLookId: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipLastLookAnswerRequest
     */
    answer: HomeownershipLastLookAnswerRequestAnswerEnum;
}


/**
 * @export
 */
export const HomeownershipLastLookAnswerRequestAnswerEnum = {
    Match: 'match',
    Pass: 'pass'
} as const;
export type HomeownershipLastLookAnswerRequestAnswerEnum = typeof HomeownershipLastLookAnswerRequestAnswerEnum[keyof typeof HomeownershipLastLookAnswerRequestAnswerEnum];


/**
 * Check if a given object implements the HomeownershipLastLookAnswerRequest interface.
 */
export function instanceOfHomeownershipLastLookAnswerRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "lastLookId" in value;
    isInstance = isInstance && "answer" in value;

    return isInstance;
}

export function HomeownershipLastLookAnswerRequestFromJSON(json: any): HomeownershipLastLookAnswerRequest {
    return HomeownershipLastLookAnswerRequestFromJSONTyped(json, false);
}

export function HomeownershipLastLookAnswerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipLastLookAnswerRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
        'lastLookId': json['last_look_id'],
        'answer': json['answer'],
    };
}

export function HomeownershipLastLookAnswerRequestToJSON(value?: HomeownershipLastLookAnswerRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
        'last_look_id': value.lastLookId,
        'answer': value.answer,
    };
}

